import { CertificateIcon } from './CertificateIcon';

/**
 * author: Simran
 * id 2DBEB397-D80B-445D-A11E-7B8362CFBEF4
 * name certificate
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/certificate.svg
 * tags
 */
export const DiplomaIcon = CertificateIcon;
export default DiplomaIcon